import { Stack, type StackProps, styled } from '@lingoda/ui';
import { resolveProtocol } from '@lingoda/urls';

type Props = {
    desktopImageUrl: string | undefined;
    themeMode: 'light' | 'dark';
} & Pick<StackProps, 'justifyContent'>;

export const DesktopBackgroundImageStack = ({
    desktopImageUrl,
    themeMode,
    children,
    ...restProps
}: React.PropsWithChildren<Props>) => {
    return (
        <StackStyled desktopImageUrl={desktopImageUrl} themeMode={themeMode} {...restProps}>
            {children}
        </StackStyled>
    );
};

const StackStyled = styled(Stack, {
    shouldForwardProp: (prop) => prop !== 'desktopImageUrl',
})<Pick<Props, 'desktopImageUrl' | 'themeMode'>>(({ theme, desktopImageUrl, themeMode }) => ({
    position: 'relative',
    gap: theme.spacing(1.5),
    paddingTop: 0,
    paddingLeft: 0,
    paddingRight: 0,
    paddingBottom: theme.spacing(4),
    alignItems: 'center',
    textAlign: 'center',
    color: themeMode === 'light' ? 'inherit' : theme.colors.text.inverse,

    [theme.breakpoints.up('sm')]: {
        gap: theme.spacing(1),
        paddingTop: theme.spacing(4),
        paddingLeft: theme.spacing(3),
        paddingRight: theme.spacing(3),
        alignItems: 'normal',
        textAlign: 'left',
        minHeight: 324,
        borderRadius: theme.shape.borderRadius,
        boxShadow: theme.shadows[1],
        backgroundImage: `url(${resolveProtocol(desktopImageUrl ?? '')})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
    },
}));
